import sx from 'utils/createSx';

export default sx({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 2,
    pt: 1,
    width: '100%',
  },
  avatar: { width: 88, height: 88 },
  textBlock: { textAlign: 'center', width: '100%' },
  name: { fontWeight: 600 },
  email: { mt: 0.5, wordBreak: 'break-word' },
  typeCaption: { display: 'block', mt: 1 },
});
